module.exports = __webpack_public_path__ + "static/media/raspberry-pi.1990089d.svg";